function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { Text } from "../../Text/Text/Text";
import styles from "./FooterSection.module.scss";
import { Button } from "../../Button/Button/Button";
import classnames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var FooterSection = function FooterSection(_ref) {
  var button = _ref.button,
    headline = _ref.headline,
    secondaryButton = _ref.secondaryButton,
    footnote = _ref.footnote,
    _ref$version = _ref.version,
    version = _ref$version === void 0 ? 'v1' : _ref$version;
  var hasButton = !!(button && button.children && button.url);
  var hasSecondaryButton = !!(secondaryButton && secondaryButton.children && secondaryButton.url);
  var hasTwoButtons = hasButton && hasSecondaryButton;
  var hasOneButton = (hasButton || hasSecondaryButton) && !hasTwoButtons;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: classnames(styles.footerSectionContainer, {
        [styles.footerSectionContainerV1]: ['v1', 'v3'].includes(version),
        [styles.twoButtons]: hasTwoButtons,
        [styles.oneButton]: hasOneButton,
        [styles.hasFootnote]: !!footnote
      }),
      children: [headline && /*#__PURE__*/_jsx(Text, {
        richText: true,
        textElement: "span",
        typog: headline.typog,
        className: styles.heading,
        children: headline.text
      }), /*#__PURE__*/_jsxs("div", {
        className: classnames(styles.buttonContainer, {
          [styles.buttonContainerV1]: ['v1', 'v3'].includes(version),
          [styles.twoButtons]: hasTwoButtons,
          [styles.oneButton]: hasOneButton
        }),
        children: [hasButton && /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
          className: styles.button
        }, button), {}, {
          children: button === null || button === void 0 ? void 0 : button.children
        })), hasSecondaryButton && /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
          className: "".concat(styles.button, " ").concat(styles.buttonSecondary)
        }, secondaryButton), {}, {
          children: secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.children
        }))]
      })]
    }), footnote && /*#__PURE__*/_jsx(Text, {
      className: styles.footnote,
      typog: "captionSmall",
      richText: true,
      children: footnote
    })]
  });
};